export default function dashboardDirective() {
  console.log('app.components.global.dashboard created');
  return {
    template: require('./dashboard.directive.html'),
    controller: 'DashboardDirectiveController',
    controllerAs: 'dashboardVM',
    bindToController: true,
    replace: true,
    scope: {},
  };
}
